import lazyWithRetry from "../../../helpers/lazyWithRetry";

/** Page Groupes d'hôtels, montée par router.tsx sous `/settings/hotel-groups` (dans un Suspense). */
export const HotelGroupsIndex = lazyWithRetry(() => import("./Index"));
